import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const ChbkClaimLineList = ({ chbkClaimObj: chbkClaim }) => {
  
  const augRowsReq = useCallback((rowsReq) => {
    if (!chbkClaim) return;

    rowsReq.partition = chbkClaim.partition;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('chbkClaimId', chbkClaim.id, 'rcvdPeriodId', chbkClaim.rcvdPeriodId));
  }, [chbkClaim?.partition, chbkClaim?.id, chbkClaim?.rcvdPeriodId]);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Claim Lines come from system only
  }

  return (
    <EntityList entity="CHBK_CLAIM_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons}/>
  )
}
